module.exports = __webpack_public_path__ + "img/P1.9010000a.png";